export const isHalloween = process.env.NEXT_PUBLIC_THEME === 'halloween';
export const isChristmas = process.env.NEXT_PUBLIC_THEME === 'christmas';